/**
 * Dependencies
 */
import { get } from 'lodash'

/**
 * Get the current user's plan ID
 *
 * @param  {Object} state
 * @return {Number}
 */
const currentPlanId = (state) => {
    let plan = state.plans.find(plan => plan.name === get(state.data, 'name', null))

    return plan ? plan.id : null
}

/**
 * Get the current plan billing period
 *
 * @param  {Object} state
 * @return {Number}
 */
const currentBillingPeriod = (state) => {
    return state.data.name
        ? state.data.name.includes('Monthly') ? 0 : 1
        : null
}

/**
 * Determine if the plans have been loaded from the API
 *
 * @param  {Object} state
 * @return {Boolean}
 */
const plansLoaded = (state) =>
    state.plans.length > 0

/**
 * Determine if there is a pending subscription
 *
 * @param  {Object} state
 * @return {Boolean}
 */
const hasPendingSubscription = (state) =>
    state.data.pending_subscription !== null

/**
 * Determine if the user has a basic plan
 *
 * @param  {Object} state
 * @return {Boolean}
 */
const hasBasicPlan = (state) =>
    state.data.name === 'Basic Monthly' || state.data.name === 'Basic Annually'

/**
 * Total licenses
 *
 * @return {Number}
 */
const totalLicenses = (state) =>
    state.licenses.length

/**
 * Total available licenses
 *
 * @param  {Object} state
 * @return {Number}
 */
const licenseCount = (state) =>
    state.licenses.reduce((result, item) => {
        !item.user
            ? result.available++
            : result.used++
        return result
    }, { available: 0, used: 0 })

/**
 * Determine whether the user has requested additional licenses
 *
 * @param  {Object} state
 * @return {Boolean}
 */
const isRequestingAdditionalLicenses = (state) =>
    state.preview.licenses > 0

export default {
    plansLoaded,
    licenseCount,
    hasBasicPlan,
    currentPlanId,
    totalLicenses,
    currentBillingPeriod,
    hasPendingSubscription,
    isRequestingAdditionalLicenses
}



// WEBPACK FOOTER //
// ./src/state/modules/user/subscription/getters.js